import React, { useEffect, useState } from "react";
import Head from "../../layout/head/Head";
import { useForm } from "react-hook-form";
import Content from "../../layout/content/Content";
import { Block, Col, PreviewAltCard, Row } from "../../components/Component";
import { Form, Offcanvas, OffcanvasBody, OffcanvasHeader } from "reactstrap";
import MyButton from "../../MyComp/UI/form/MyButton";
import Status from "../../MyComp/UI/form/Status";
import MyInput from "../../MyComp/UI/form/MyInput";
import { createPrakrityCategoryAPI, listPrakrityCategoryAPI, updatePrakrityCategoryAPI } from "../../api/master/indes";

import ConfirmModal from "../../MyComp/UI/modals/ConfirmModal";
import { toast } from "react-toastify";
import useLogout from "../../hooks/useLogout";

import ViewImage from "../../MyComp/UI/modals/ViewImage";

import Table from "../../MyComp/UI/DataTable/Table";
const PrakrityCategory = () => {
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,

    formState: { errors },
  } = useForm({
    defaultValues: {
      isLoading: false,
      data: [],

      tableLoading: true,

      isPub: false,
    },
  });
  const logout = useLogout();
  const tableLoading = watch("tableLoading");
  const [isOpen, setIsOpen] = useState(false);
  const [imageOpen, setImageOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [mode, setMode] = useState("Add");
  const isLoading = watch("isLoading");
  const [data, setData] = useState([]);

  const toggleCanvas = () => {
    setIsOpen((prev) => !prev);
    if (isOpen) resetF();
  };

  const selectorCheck = (e) => {
    const updated = data.map((item) => ({ ...item, checked: e.target.checked }));
    setData(updated);
  };

  const handleImageClose = () => {
    setImageOpen(!imageOpen);
  };

  const onSelectChange = (e, id) => {
    const updated = data.map((item) => (item.id === id ? { ...item, checked: e.target.checked } : item));
    setData(updated);
  };

  useEffect(() => {
    listPrakrityCategory();
  }, []);
  const listPrakrityCategory = () => {
    setValue("isLoading", true);
    listPrakrityCategoryAPI()
      .then((res) => {
        if (res.data.status === "expired") {
          setValue("tableLoading", false);
          toast.error(res.data.message);
          logout();
        } else if (res.data.status === true) {
          setValue("tableLoading", false);
          setData(res.data.data || []);
        } else {
          setValue("tableLoading", false);
          setData([]);
          toast.error(res.data.message);
        }
      })
      .catch((err) => toast.error(err?.response?.data?.message))
      .finally(() => setValue("isLoading", false));
  };
  const onFormSubmit = () => {
    const body = {
      name: watch("name"),
      status: watch("status")?.value,
      ...(mode === "Edit" && { id: watch("selectedRow")?.id }),
    };

    setValue("isLoading", true);

    if (mode === "Add") {
      createPrakrityCategoryAPI(body)
        .then((res) => {
          if (res.data.status === true) {
            toast.success(res.data.message);

            listPrakrityCategory();
            setIsOpen(false);
            resetF();
          } else if (res.data.status === "expired") {
            logout();
          } else {
            toast.error(res.data.message);
          }
        })
        .catch((err) => toast.error(err?.response?.data?.message))
        .finally(() => setValue("isLoading", false));
    }

    if (mode === "Edit") {
      updatePrakrityCategoryAPI(body)
        .then((res) => {
          if (res.data.status === true) {
            toast.success(res.data.message);

            listPrakrityCategory();
            setIsOpen(false);
            resetF();
          } else if (res.data.status === "expired") {
            logout();
          } else {
            toast.error(res.data.message);
          }
        })
        .catch((err) => toast.error(err?.response?.data?.message))
        .finally(() => setValue("isLoading", false));
    }
  };

  const handleEdit = (row) => {
    window.scrollTo(0, 0);
    setValue("selectedRow", row);
    setIsOpen(true);
    setMode("Edit");
    setValue("name", row?.category_name);
    setValue("status", {
      label: row.status ? "Active" : "InActive",
      value: row.status,
    });
  };
  const handleToggleStatus = (row) => {
    setValue("selectedRow", row);
    setShowModal(true);
  };
  const confirmStatusChange = (data) => {
    const updatedStatus = watch("selectedRow").status === true ? false : true;
    setValue("isLoading", true);
    const formObject = {
      id: watch("selectedRow").id,
      status: updatedStatus,
    };
    updatePrakrityCategoryAPI(formObject)
      .then((res) => {
        //const status = decrypt(res.data.status);
        if (res.data.status === true) {
          toast.success(res.data.message);
          toast.clearWaitingQueue();
          listPrakrityCategory();
          setIsOpen(false);
          setValue("isLoading", false);
          setShowModal(false);
        } else if (res.data.status === false) {
          setValue("isLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          setValue("isLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        setValue("isLoading", false);
        toast.error(err?.response?.data?.message);
      });
  };

  const resetF = () => {
    setValue("name", null);
    setValue("status", "");
    setMode("Add");
  };
  return (
    <>
      <Head title={" Prakrity Category  | Master"} />
      <Content>
        {/* <BlockHead size={`sm`}>
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page tag="h3">
                {"Manage Products"}
              </BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="">
                <Button
                  color="primary"
                  outline
                  className={`  me-n1`}
                  onClick={() => {
                    setIsOpen((pre) => !pre);
                    resetF();
                  }}
                >
                  <Icon name={isOpen ? "minus" : "plus"} />
                </Button>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead> */}
        <Block>
          <>
            {" "}
            <div className="container my-5 text-center">
              {/* Button to open offcanvas */}

              <Offcanvas isOpen={isOpen} direction="end">
                <OffcanvasHeader toggle={toggleCanvas}>Prakiry Category </OffcanvasHeader>
                <OffcanvasBody>
                  <PreviewAltCard>
                    <Form onSubmit={handleSubmit(onFormSubmit)}>
                      <Row>
                        <Col md="12" className={``}>
                          <MyInput
                            register={register}
                            watch={watch}
                            setValue={setValue}
                            trigger={trigger}
                            errors={errors}
                            title={"Name"}
                            name={"name"}
                            placeholder={"Enter name"}
                            required
                            min={2}
                            max={50}
                          />
                        </Col>
                        <Col md={`12`}>
                          <Status
                            register={register}
                            watch={watch}
                            setValue={setValue}
                            trigger={trigger}
                            errors={errors}
                          />
                        </Col>
                      </Row>
                      <Col md="12" className={``}>
                        <div className="form-group" style={{ marginTop: "31px" }}>
                          <MyButton isLoading={isLoading} mode={mode} />
                        </div>
                      </Col>
                    </Form>
                  </PreviewAltCard>
                </OffcanvasBody>
              </Offcanvas>

              {/* Offcanvas (Right Side) */}
            </div>
          </>

          <Table
            title="Prakrity Category"
            data={data}
            publicButton={false}
            columns={[{ key: "category_name", label: "Name" }]}
            searchKeys={["category_name"]}
            nameColumn={"name"}
            onEditClick={handleEdit}
            selectorCheck={selectorCheck}
            onSelectChange={onSelectChange}
            statusFilterEnabled={true}
            isOpen={isOpen}
            confirmStatusChange={confirmStatusChange}
            setIsOpen={setIsOpen}
            resetF={resetF}
            handleToggleStatus={handleToggleStatus}
            toggleCanvas={toggleCanvas}
            isLoading={tableLoading}
          />
        </Block>
      </Content>

      <ConfirmModal
        isOpen={showModal}
        toggle={() => {
          setShowModal(!showModal);
          setValue("isPub", false);
        }}
        onConfirm={confirmStatusChange}
        status={watch("selectedRow")?.status}
        isPub={watch("isPub")}
        data={watch("selectedRow")}
      />
    </>
  );
};

export default PrakrityCategory;
